import { Sidetab } from "@typeform/embed-react";
import { useEffect, useRef, useState } from "react";

const SUBMITTED_STORAGE_KEY = "atlas-survey-pWMd4FbX-submitted";

const SurveyWidget = () => {
  // Prerender runs this component in Node where `localStorage` and the
  // Typeform widget DOM bindings aren't available. Defer mount + storage
  // read until the client has hydrated.
  const [mounted, setMounted] = useState(false);
  const [hidden, setHidden] = useState(false);
  const submittedRef = useRef(false);

  useEffect(() => {
    setHidden(localStorage.getItem(SUBMITTED_STORAGE_KEY) === "true");
    setMounted(true);
  }, []);

  if (!mounted || hidden) return null;

  return (
    <Sidetab
      id="pWMd4FbX"
      buttonText="HELP US IMPROVE THE ATLAS"
      buttonColor="#243844"
      buttonTextColor="#ffffff"
      buttonTextSize={14}
      buttonWidth={25}
      buttonHeight={210}
      hidden={{ footer: true }}
      autoClose={3000}
      onSubmit={() => {
        localStorage.setItem(SUBMITTED_STORAGE_KEY, "true");
        submittedRef.current = true;
      }}
      onClose={() => {
        if (submittedRef.current) setHidden(true);
      }}
    />
  );
};

export default SurveyWidget;
